import React from "react";
import { Header } from "../Header/Header";
import styles from "./SignupPending.module.css";

export const SignupPending = () => (
  <div className={styles.wrapper}>
    <Header />
    <div className={styles.cardContainer}>
      <div className={styles.card}>
        <div className={styles.iconWrapper}>
          <span className={styles.icon}>✓</span>
        </div>
        <h1 className={styles.title}>We've got your request.</h1>
        <p className={styles.description}>
          Our team is reviewing your application. Most reviews finish within
          24 hours. You'll get an email the moment we're ready — then your
          account opens.
        </p>
        <p className={styles.small}>
          In the meantime, if anything changes, just reply to the confirmation
          email.
        </p>
      </div>
    </div>
  </div>
);